import React from "react";
import "./OfferCard.css";
import { useTranslation } from "react-i18next";



const OfferCard = ({ data, index, club }) => {
    const { t } = useTranslation();

    const onManagePunch = (pointsPurchased) => {
        const newArray = [];

        for (let i = 1; i <= pointsPurchased; i++) {
            if (i > 20) {
                break;
            }

            if (i === pointsPurchased) {
                newArray.push(-11);
            } else {
                newArray.push(i);
            }
        }

        return newArray;
    };


    console.log(data?.smallPicturlUrl);
    return (
        <div className="offer-card rtl" key={`item-offer${index}`}>
            <div className="offer-image-container">
                <img
                    src={data?.smallPicturlUrl}
                    alt="offer"

                    className="offer-image"


                />
                <div className="offer-price-badge">
                    <span>{`₪${data?.price}`}</span>
                </div>
                <div className="offer-line-big"></div>
            </div>
            <div className="offer-content">
                <h3 className="offer-title">{data?.description}</h3>
                <div className="offer-points">
                    {onManagePunch(data?.points).map((e, idx) => (
                        <div key={idx} className={`point ${e === -11 ? "gift" : ""}`}>
                            {e === -11 ? (
                                <img
                                    src="/images/gift-box.png"
                                    alt="gift"
                                    className="gift-icon"
                                />
                            ) : (
                                <span>{e}</span>
                            )}
                        </div>
                    ))}
                </div>
                <div className="offer-line-small">
                    <div className="offer-description">
                        <p className="long-description">{data?.longDescription}</p>
                        <p className="expiration">{data?.usageExpirationPeriodText}</p>
                    </div>
                    <div className="offer-actions">
                        <a href={club?.deepLink} className="app-link">
                            {t("לקנייה באפליקציה")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferCard;